// Entrar como vendedor (decisión D60): el preventista entra a la tienda con el correo y la contraseña de su usuario de
// la distribuidora (el mismo del panel o de la app del chofer). Hace falta un rol con "Tomar pedidos en el local"; la
// tienda queda en modo vendedor, con su cartera.
import { Icono } from '@reparto/ui';
import { type FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { Aviso, Boton } from '../componentes/base';
import { Bienvenida } from '../componentes/Bienvenida';
import { CampoClave, CampoTexto } from '../componentes/Campos';
import { ErrorApi, mensajeDeError } from '../datos/api';
import { entrarComoVendedor } from '../datos/cuenta';
import { correoLimpio, errorCorreo } from '../datos/entrada';
import { cargarMarca, useMarca } from '../datos/marca';

export function EntrarVendedor() {
  const marca = useMarca((s) => s.marca);
  const navegar = useNavigate();
  const [email, setEmail] = useState('');
  const [clave, setClave] = useState('');
  const [errorEmail, setErrorEmail] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);
  const nombre = marca?.nombre ?? 'la distribuidora';

  async function entrar(ev: FormEvent) {
    ev.preventDefault();
    setError(null);
    const e = errorCorreo(email);
    setErrorEmail(e);
    if (e) return;
    if (!clave) return setError('Escribí tu contraseña.');
    setOcupado(true);
    try {
      await entrarComoVendedor(correoLimpio(email), clave);
      navegar('/visitas', { replace: true });
    } catch (x) {
      if (x instanceof ErrorApi && x.codigo === 'TIENDA_CERRADA') void cargarMarca();
      setError(mensajeDeError(x));
      setOcupado(false);
    }
  }

  return (
    <Bienvenida marca={marca}>
      <Link
        to="/entrar"
        className="-mt-2 mb-4 -ml-2 inline-flex min-h-11 items-center gap-1 rounded-full px-2 text-[15px] font-medium text-stone-700 hover:bg-stone-200/60"
      >
        <Icono nombre="chevron_left" tamano={22} />
        Soy cliente
      </Link>
      <form onSubmit={entrar} noValidate className="flex flex-col gap-5">
        <div>
          <h2 className="text-2xl font-bold">Entrar como vendedor</h2>
          <p className="mt-1 text-stone-600">
            Con el correo y la contraseña de tu usuario de {nombre}. Les tomás el pedido a los clientes de tu cartera,
            con sus precios.
          </p>
        </div>
        <CampoTexto
          etiqueta="Correo"
          icono="mail"
          type="email"
          inputMode="email"
          autoComplete="username"
          autoCapitalize="none"
          spellCheck={false}
          placeholder="nombre@distribuidora.com"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (errorEmail) setErrorEmail(null);
          }}
          error={errorEmail}
        />
        <CampoClave
          etiqueta="Contraseña"
          autoComplete="current-password"
          value={clave}
          onChange={(e) => setClave(e.target.value)}
        />
        {error ? (
          <Aviso tono="peligro" icono="error">
            <span role="alert">{error}</span>
          </Aviso>
        ) : null}
        <Boton type="submit" bloque tamano="lg" icono="badge" cargando={ocupado} className="text-lg!">
          Entrar como vendedor
        </Boton>
      </form>
      <p className="mt-8 border-t border-stone-200 pt-6 text-center text-[15px] text-stone-600">
        ¿No tenés usuario o no te deja entrar? Pedile al administrador de {nombre} el rol <b>Preventista</b>.
      </p>
    </Bienvenida>
  );
}
